import { useLink } from '@react-aria/link';
import { ReactElement, useRef } from 'react';

import Loader from '../../components/Loader';
import { Wrapper } from './styles';
import { TextButtonProps } from './types';

/**
 *
 * Displays a Button styled as text (what would typically be an Anchor tag)
 * For accessibility reasons, clickable text without an href should be a button, not an anchor.
 *
 */

const TextButton = ({
	children,
	className,
	isDisabled,
	isLoading,
	onClick,
	size,
	textColor,
	type,
	weight,
	hideUnderline = false,
	...props
}: TextButtonProps): ReactElement => {
	const ref = useRef(null);
	const { linkProps } = useLink(
		{
			onPress: onClick,
			isDisabled: isDisabled || isLoading,
			...props,
		},
		ref,
	);
	const color = textColor || 'textButton';

	return (
		<Wrapper
			className={className}
			$size={size}
			$textColor={color}
			type={type ?? 'button'}
			disabled={isDisabled}
			$isLoading={isLoading}
			$hideUnderline={hideUnderline}
			$weight={weight}
			ref={ref}
			{...linkProps}
		>
			{isLoading ? (
				<>
					<Loader color={color} />
					{children}
				</>
			) : (
				children
			)}
		</Wrapper>
	);
};

export default TextButton;
